import Vuex from 'vuex'
import i18n from '../lang/i18n.js'
import axios from 'axios'
import router from '@/router/index'
import login from '@/store/modules/login.js'
import borradores from '@/store/modules/borradores.js'
import usuarios from '@/store/modules/usuarios.js'
import servicios from '@/store/modules/servicios.js'
import cierrescontables from '@/store/modules/cierrescontables.js'
import recepciones from '@/store/modules/recepciones.js'
import pedidos from '@/store/modules/pedidos.js'
import cierrescontablesBorradores from '@/store/modules/cierrescontablesBorradores.js'
import profile from '@/store/modules/profile.js'
import profiles from '@/store/modules/profiles.js'
import taxes from '@/store/modules/taxes.js'
import tareaspendientes from '@/store/modules/tareaspendientes.js'
import creacionFactura from '@/store/modules/creacionFactura.js'
import creacionAlbaran from '@/store/modules/creacionAlbaran.js'
import centros from '@/store/modules/centros.js'
import facturas from '@/store/modules/facturas.js'
import filtros from '@/store/modules/filtros.js'
import issues from '@/store/modules/issues.js'
import documentacion from '@/store/modules/documentacion.js'
import auditorias from '@/store/modules/auditorias.js'
import auditoriaAcciones from '@/store/modules/auditoriaAcciones.js'
import plantillasdecorreo from '@/store/modules/plantillasdecorreo.js'
import estadistica from '@/store/modules/statistics.js'
import albaranes from '@/store/modules/albaranes.js'
import cmr from '@/store/modules/cmr.js'
import genrals from '@/store/modules/genrals.js'
import procesosPlanificados from '@/store/modules/procesosPlanificados.js'
import mailServer from '@/store/modules/mailServer.js'
import ocrDocuments from '@/store/modules/ocrDocument.js'
import fn from '../utils/functions'
import communicationMethod from '@/store/modules/communicationMethod'
import articles from '@/store/modules/articles.js'
import userInformation from '@/store/modules/userInformation.js'
import salesReport from '@/store/modules/salesReport.js'
import inventoryReport from './modules/inventoryReport.js'
import remadv from './modules/remadv.js'
import coacsu from './modules/coacsu.js'

const browserLocale = require('browser-locale')

/*
  Serivicios Creados en Actions:

  USUARIO:
    1. action: login, url: '/session'
    1. action: logout, url: '/session'
    2. action: resetPassChallenge, url: '/forgottenpassword/challenge'
    2. action: resetPassChallengeSolved, url: '/forgottenpassword/challenge'
    3. action: getOptionsFilterInvoiceReceiveBuyer, url: '/me/partywithcommercialrelationship'
    3. action: getOptionsFilterEmitterAudits, url: '/me/partywithcommercialrelationship'
    3. action: getOptionsFilterReceiverAudits, url: '/me/partywithcommercialrelationship'
    4. action: getOptionsService, url: '/me/project'
    4. action: getUserProjectsList, url: '/me/project'
    5. url: '/me/protocol'

  DATOS FACTURAS:
    1. url: '/invoicenote'

  DATOS AUDITORIAS:
    1. url: '/auditorydocument'

  METODOS COMUNES (/constant/)
    1. url: '/constant/auditstatus'
    2. url: '/constant/communicationprotocol'
    3. url: '/constant/invoicestatus'
    4. url: '/constant/documentclass'
    5. url: '/constant/taxtype'
    6. url: '/constant/currency'
    7- action: getOptionsFilterFormatDocumentType, url: '/constant/documenttype/{documentTypeId}/format
    8. url: '/constant/accountingclosestatus'

*/

function deleteModulesFromStateLocal (copyLocal) {
  delete copyLocal.login
  delete copyLocal.usuarios
  delete copyLocal.borradores
  delete copyLocal.servicios
  delete copyLocal.recepciones
  delete copyLocal.pedidos
  delete copyLocal.cierrescontables
  delete copyLocal.cierrescontablesBorradores
  delete copyLocal.profile
  delete copyLocal.profiles
  delete copyLocal.taxes
  delete copyLocal.mailServer
  delete copyLocal.tareaspendientes
  delete copyLocal.creacionFactura
  delete copyLocal.creacionAlbaran
  delete copyLocal.centros
  delete copyLocal.facturas
  delete copyLocal.filtros
  delete copyLocal.issues
  delete copyLocal.documentacion
  delete copyLocal.auditorias
  delete copyLocal.auditoriaAcciones
  delete copyLocal.plantillasdecorreo
  delete copyLocal.procesosPlanificados
  delete copyLocal.estadistica
  delete copyLocal.albaranes
  delete copyLocal.genrals
  delete copyLocal.cmr
  delete copyLocal.ocrDocuments
  delete copyLocal.communicationMethod
  delete copyLocal.articles
  delete copyLocal.salesReport
  delete copyLocal.inventoryReport
  delete copyLocal.remadv
  delete copyLocal.coacsu
}

function isNewVersion (state, local) {
  const copyLocal = structuredClone(local)
  deleteModulesFromStateLocal(copyLocal)
  /*
   * Al .length de state.local tenemos que restarle 1 porque trae siempre una clave mas denominada
   * _ob_, que es un observador
  */
  if (state.local && copyLocal) {
    return (Object.getOwnPropertyNames(state.local).length - 1) !== Object.getOwnPropertyNames(copyLocal).length
  } else {
    return true
  }
}

/* Funcion para obtener el locale por defecto del navegador, quedándonos solo con el primer
* string representativo del idioma
*/
function getBrowserLocale () {
  const locale = browserLocale()
  const lang = locale.split('-')
  const langs = ['es', 'it', 'pt', 'en']
  if (langs.includes(lang[0])) {
    return lang[0]
  } else {
    return 'en'
  }
}

function initSession () {
  const session = {
    // Usuario
    activeUser: {
      data: null,
      authToken: null,
      isActive: false
    },
    urlIn: null,
    primaryColor: null,
    secondaryColor: null,
    clientbg: null,
    jwt: null,
    recoveryPassUser: {
      username: null,
      question: null,
      answer: null,
      email: null
    },

    // Flags de permisos
    /* ADMIN */
    canCreateServices: false,
    canCreateParty: false,
    canCreateCentre: false,
    canAdminIndra: false,
    canModifyProject: false,
    canEditProjectDeliveryMethod: false,
    canEditPartyDeliveryMethod: false,
    canViewComercialRelation: false,
    canCreateComercialRelation: false,
    canAdminProject: false,
    canAdminParty: false,
    canAdminCentre: false,
    canAdminUser: false,
    canAdminPartyAdvanced: false,
    canViewBankData: false,
    canAdminProfile: false,
    canAdminQuartz: false,
    canChangePartyMedia: false,
    canModifyPaymentMethods: false,
    canViewDistributionCentres: false,
    canChangeCentreRoles: false,
    canEditOrDeleteCentreWithPermanentEstablishment: false,
    canAdminApprovalFlowByLevels: false,
    canUserApprovalFlowByLevels: false,
    canAdminArticle: false,
    canAdminMethods: false,

    /* MENU */
    canViewMenu: false,
    /* PAYROLL */
    canSearchInvoiceSales: false,
    canSearchInvoicePurchases: false,
    canSearchInvoiceThird: false,
    canSearchReportEmitted: false,
    canSearchReportReceived: false,
    /* DRAFT */
    canSearchInvoiceDraft: false,
    canCreateInvoiceDraft: false,
    canCopyInvoiceDraft: false,
    /* ACCOUNTING CLOSE */
    canSearchAccountingClose: false,
    canSearchAccountingCloseDraft: false,
    /* PENDING TAKS */
    canSearchPendingTasks: false,
    canMultipleChangeStatus: false,
    /* DOCUMENTOS OCR */
    canSearchOcrDocuments: false,
    /* DOCUMENT */
    canSeeSingDocument: false,
    canDeleteSingDocument: false,
    canAddSingDocument: false,
    /* INVOICE */
    canResendEmittedInvoices: false,
    canResendReceivedInvoices: false,
    canCreateCover: false,
    canAddBuyerCenter: false,
    canEditInvoices: false,
    canEditInternalNotes: false,
    canViewInternalNotes: false,
    canAddAttachments: false,
    canSeeAttachments: false,
    canSeeEvents: false,
    canSeeDocuments: false,
    canGetPaymentData: false,
    canSeeEventsBpm: false,
    canDeleteAttachments: false,
    canSearchChannel: false,
    canCancelInvoice: false,
    canChangeStatusInvoice: false,
    canChangeSentFlagInvoice: false,
    canChangeStatusPendingTask: false,
    canViewRequestDigitalization: false,
    canDownloadFormatted: false,
    canViewStatusColor: false,
    canCreateDraftFromRecadv: false,
    canCreateCorrectiveInvoice: false,
    cantViewInvoiceSeriesCode: false,
    cantValidateOperationDate: false,
    canViewTotalIrpf: false,
    /* AUDITORY */
    canSearchDocumentAuditory: false,
    canSearchActionAuditory: false,
    /* DOCUMENTATION */
    canConsultDocumentation: false,
    canAdminDocumentation: false,
    /* STATISTICS */
    canConsulStatistics: false,
    /* RECADV */
    canSearchRecadvSender: false,
    canSearchRecadvReceiver: false,
    canRejectRecadv: false,
    canModifyRecadv: false,
    canCreateInvoiceRecadv: false,
    canCreateInvoiceParcialRecadv: false,
    canViewAttach: false,
    canCheckStatus: false,
    canChangeStatusRecadv: false,
    cantViewRecadvPdf: false,
    /* PEDIDOS */
    canSearchOrderSender: false,
    canSearchOrderReceiver: false,
    canChangeStatusOrder: false,
    canCreateDeliveryNoteOrder: false,
    canCreateInvoiceOrder: false,
    /* CARGA FACTURA */
    canUploadInvoice: false,
    /* USUARIOS */
    canAdminUserAdvanced: false,
    canNoEditUserData: false,
    canViewMetadata: false,
    canViewOrderMetadata: false,
    canViewRecadvMetadata: false,
    canViewOrderOriginal: false,
    canViewRecadvOriginal: false,
    canViewDesadvMetadata: false,
    canViewDesadvOriginal: false,
    /* ADJUNTOS OCULTOS */
    canAttachmentHidden: false,
    /* CANAL RELACIONES COMERCIALES */
    canViewRelationChannel: false,
    /* ALBARANES */
    canSearchDeliverySender: false,
    canSearchDeliveryReceiver: false,
    canChangeStatusDeliveryNote: false,
    canCreateInvoiceDeliveryNote: false,
    /* GENRALS */
    canSearchGenralSender: false,
    canSearchGenralReceiver: false,
    /* ISSUES */
    canSearchIssue: false,
    canUpdateIssue: false,
    canDeleteIssue: false,
    canCreateIssue: false,
    /* CMR */
    canSearchCMR: false,
    canCreateCmrDraft: false,
    canViewCmrDraftSellerCentres: false,
    canViewCmrDraftBuyerCentres: false,
    canEditCarrierCMR: false,
    canEditChargerCMR: false,
    /* REPORTE DE VENTAS */
    canSearchSalesReportView: false,
    canViewSalesReportMetadata: false,
    canViewSalesReportOriginal: false,
    /* REPORTE DE INVENTARIO */
    canSearchInventoryReportView: false,
    canViewInventoryReportMetadata: false,
    canViewInventoryReportOriginal: false,
    /* COACSU / REMADV NUEVOS */
    canCreateCoacsu: false,
    canSearchCoacsuView: false,
    canViewCoacsuMetadata: false,
    canViewCoacsuOriginal: false,
    /* REMADV */
    canSearchRemadvView: false,
    canViewRemadvMetadata: false,
    canViewRemadvOriginal: false,
  }
  return session
}

function initialState () {
  const state = {
    userConfigLocalStorage: '',
    local: {
      // Nuevas
      activeLang: getBrowserLocale(),

      // Documentacion
      isShowDialogAddDocumentation: false,

      // Facturas
      invoice: {},

      // Constantes
      countries: [],
      contractors: [],
      invoiceStatus: [],

      // - Viejas - //
      invoiceModal: false,
      searchBarToggle: true,
      tableData: [],
      totalItemsTable: 100,
      invoiceFilters: {},
      ERRORS: [],
      distinctColumnData: [],
      isShowFactura: true,
      isShowEmision: true,
      isShowRegistro: true,
      isShowVendedor: true,
      isShowComprador: true,
      isShowImporte: true,
      isShowEstado: true
    },
    session: initSession()
  }
  return state
}

const store = new Vuex.Store({
  modules: {
    login,
    borradores,
    ocrDocuments,
    usuarios,
    servicios,
    recepciones,
    pedidos,
    cierrescontables,
    cierrescontablesBorradores,
    profile,
    profiles,
    taxes,
    mailServer,
    tareaspendientes,
    creacionFactura,
    creacionAlbaran,
    centros,
    facturas,
    filtros,
    issues,
    documentacion,
    auditorias,
    auditoriaAcciones,
    plantillasdecorreo,
    procesosPlanificados,
    estadistica,
    albaranes,
    genrals,
    cmr,
    communicationMethod,
    articles,
    userInformation,
    salesReport,
    inventoryReport,
    remadv,
    coacsu
  },

  state: initialState(),

  mutations: {
    // NUEVAS
    async initialStore (state) { // NOSONAR javascript:S3776
      // Check if the ID exists
      const session = JSON.parse(sessionStorage.getItem('store'))
      if (session) {
        // Aqui debemos declarar todos los modulos que insertemos en sessionStorage
        // con el siguiente formato:
        // state.<<modulo>>.sesion = session.<<modulo>>
        state.session = session
        state.usuarios.session = session.usuarios
        state.borradores.session = session.borradores
        state.servicios.session = session.servicios
        state.recepciones.session = session.recepciones
        state.pedidos.session = session.pedidos
        state.cierrescontables.session = session.cierrescontables
        state.cierrescontablesBorradores.session = session.cierrescontablesBorradores
        state.profile.session = session.profile
        state.profiles.session = session.profiles
        state.taxes.session = session.taxes
        state.mailServer.session = session.mailServer
        state.tareaspendientes.session = session.tareaspendientes
        state.creacionFactura.session = session.creacionFactura
        state.creacionAlbaran.session = session.creacionAlbaran
        state.centros.session = session.centros
        state.facturas.session = session.facturas
        state.issues.session = session.issues
        state.filtros.session = session.filtros
        state.documentacion.session = session.documentacion
        state.auditorias.session = session.auditorias
        state.auditoriaAcciones.session = session.auditoriaAcciones
        state.plantillasdecorreo.session = session.plantillasdecorreo
        state.procesosPlanificados.session = session.procesosPlanificados
        state.estadistica.session = session.estadistica
        state.albaranes.session = session.albaranes
        state.genrals.session = session.genrals
        state.cmr.session = session.cmr
        state.ocrDocuments.session = session.ocrDocuments
        state.communicationMethod.session = session.communicationMethod
        state.articles.session = session.articles
        state.salesReport.session = session.salesReport
        state.inventoryReport.session = session.inventoryReport
        state.remadv.session = session.remadv || state.remadv.session
        state.coacsu.session = session.coacsu || state.coacsu.session
        this.replaceState(
          Object.assign(state, state)
        )
      }
      if (localStorage.getItem('local') === null) { /* empty */ } else {
        const local = JSON.parse(localStorage.getItem('local'))
        /*
        * Comprobamos que no se hayan insertado nuevos valores en local, ya que
        * si se han insertado, hay que machacar el contenido de localStorage con el state.local
        */
        const isnewVersionLocalStorage = await this.dispatch('isNewVersionLocalState', (state, local))
        if (isnewVersionLocalStorage) {
          localStorage.setItem('local', JSON.stringify(state.local))
        } else {
          // Obtenemos el valor del locale para el idioma
          i18n.locale = local.activeLang

          // Aqui debemos declarar todos los modulos que insertemos en localStorage
          // con el siguiente formato:
          // state.<<modulo>>.local = session.<<modulo>>
          state.local = local
          state.login.local = local.login
          state.usuarios.local = local.usuarios
          state.borradores.local = local.borradores
          state.servicios.local = local.servicios
          state.recepciones.local = local.recepciones
          state.pedidos.local = local.pedidos
          state.cierrescontables.local = local.cierrescontables
          state.cierrescontablesBorradores.local = local.cierrescontablesBorradores
          state.profile.local = local.profile
          state.profiles.local = local.profiles
          state.taxes.local = local.taxes
          state.mailServer.local = local.mailServer
          state.tareaspendientes.local = local.tareaspendientes
          state.creacionFactura.local = local.creacionFactura
          state.creacionAlbaran.local = local.creacionAlbaran
          state.centros.local = local.centros
          state.facturas.local = local.facturas
          state.issues.local = local.issues
          state.filtros.local = local.filtros
          state.documentacion.local = local.documentacion
          state.auditorias.local = local.auditorias
          state.auditoriaAcciones.local = local.auditoriaAcciones
          state.plantillasdecorreo.local = local.plantillasdecorreo
          state.procesosPlanificados.local = local.procesosPlanificados
          state.estadistica.local = local.estadistica
          state.albaranes.local = local.albaranes
          state.genrals.local = local.genrals
          state.cmr.local = local.cmr
          state.ocrDocuments.local = local.ocrDocuments
          state.communicationMethod.local = local.communicationMethod
          state.articles.local = local.articles
          state.salesReport.local = local.salesReport
          state.inventoryReport.local = local.inventoryReport
          state.remadv.local = local.remadv
          state.coacsu.local = local.coacsu || state.coacsu.local
          this.replaceState(
            Object.assign(state, state)
          )
        }
        if (state.session.jwt === null) {
          // Para ahorrarnos la llamada al servicio
          try {
            if (state.session.urlIn == null) {
              if (router.currentRoute.name === 'consultInvoiceByLink') {
                router.push({ name: 'consultInvoiceByLink' }).catch(error => console.log('push exception', error))
              } else if (router.currentRoute.name === 'vocento') {
                router.push({ name: 'vocento' }).catch(error => console.log('push exception', error))
              } else if (Vue.prototype.$keycloak) {
                  Vue.prototype.$keycloak.login()
                }
            } else {
              router.push({ name: fn.assignLoginName(state.session.urlIn) }).catch(error => console.log('push exception', error))
            }
          } catch (error) { console.log('Exception push', error) }
        } else if (router.currentRoute.name === 'consultInvoiceByLink') {
            router.push({ name: 'consultInvoiceByLink' }).catch(error => console.log('push exception', error))
          } else if (router.currentRoute.name === 'vocento') {
            router.push({ name: 'vocento' }).catch(error => console.log('push exception', error))
          } else {
            axios.defaults.headers.common.Authorization = state.session.jwt
            router.push({
              name: 'b2b-app'
            })
          }
      }
    },
    'ACTIVE_LANG_STATE' (state, payload) {
      state.local.activeLang = payload
      const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
      if (storeuser) {
        storeuser.activeLang = payload
        localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
      }
    },

    // Usuarios
    'ACTIVE_USER_STATE' (state, payload) {
      state.session.activeUser = payload
    },
    'JWT_STATE' (state, payload) {
      state.session.jwt = payload
    },
    'URL_IN_STATE' (state, payload) {
      state.session.urlIn = payload
    },
    'PRIMARY_COLOR_STATE' (state, payload) {
      state.session.primaryColor = payload
    },
    'SECONDARY_COLOR_STATE' (state, payload) {
      state.session.secondaryColor = payload
    },
    'CLIENTBG_COLOR_STATE' (state, payload) {
      state.session.clientbg = payload
    },
    'RECOVERY_PASS_USER_STATE' (state, payload) {
      state.session.recoveryPassUser = payload
    },
    'RESET_SESSION_PERMISSIONS' (state) {
      // Limpiar todos los permisos para acceso público
      state.session.canViewMenu = false
      state.session.canCreateServices = false
      state.session.canCreateParty = false
      state.session.canCreateCentre = false
      state.session.canAdminIndra = false
      state.session.canModifyProject = false
      state.session.canEditProjectDeliveryMethod = false
      state.session.canEditPartyDeliveryMethod = false
      state.session.canViewComercialRelation = false
      state.session.canCreateComercialRelation = false
      state.session.canAdminProject = false
      state.session.canAdminParty = false
      state.session.canAdminUser = false
      state.session.canAdminPartyAdvanced = false
      state.session.canViewBankData = false
      state.session.canAdminProfile = false
      state.session.canAdminProfiles = false
      state.session.canAdminTaxes = false
      state.session.canAdminArticle = false
      state.session.canAdminMethods = false
      state.session.canAdminQuartz = false
      state.session.canAdminDocumentation = false
      state.session.canChangePartyMedia = false
      state.session.canModifyPaymentMethods = false
      state.session.canViewDistributionCentres = false
      state.session.canChangeCentreRoles = false
      state.session.canEditOrDeleteCentreWithPermanentEstablishment = false
      state.session.canAdminApprovalFlowByLevels = false
      state.session.canUserApprovalFlowByLevels = false
      state.session.canSearchInvoiceSales = false
      state.session.canSearchInvoicePurchases = false
      state.session.canSearchInvoiceThird = false
      state.session.canSearchReportEmitted = false
      state.session.canSearchReportReceived = false
      state.session.canSearchInvoiceDraft = false
      state.session.canCreateInvoiceDraft = false
      state.session.canCopyInvoiceDraft = false
      state.session.canSearchAccountingClose = false
      state.session.canSearchAccountingCloseDraft = false
      state.session.canSearchPendingTasks = false
      state.session.canSearchOcrDocuments = false
      state.session.canSeeSingDocument = false
      state.session.canDeleteSingDocument = false
      state.session.canAddSingDocument = false
      state.session.canResendEmittedInvoices = false
      state.session.canResendReceivedInvoices = false
      state.session.canCreateCover = false
      state.session.canAddBuyerCenter = false
      state.session.canEditInvoices = false
      state.session.canEditInternalNotes = false
      state.session.canViewInternalNotes = false
      state.session.canAddAttachments = false
      state.session.canSeeAttachments = false
      state.session.canSeeEvents = false
      state.session.canSeeDocuments = false
      state.session.canGetPaymentData = false
      state.session.canSeeEventsBpm = false
      state.session.canDeleteAttachments = false
      state.session.canSearchChannel = false
      state.session.canCancelInvoice = false
      state.session.canChangeStatusPendingTask = false
      state.session.canChangeStatusInvoice = false
      state.session.canChangeSentFlagInvoice = false
      state.session.canViewRequestDigitalization = false
      state.session.canDownloadFormatted = false
      state.session.canViewStatusColor = false
      state.session.canCreateDraftFromRecadv = false
      state.session.canCreateCorrectiveInvoice = false
      state.session.cantViewInvoiceSeriesCode = false
      state.session.canViewTotalIrpf = false
      state.session.canSearchDocumentAuditory = false
      state.session.canSearchActionAuditory = false
      state.session.canConsultDocumentation = false
      state.session.canConsulStatistics = false
      state.session.canSearchRecadvSender = false
      state.session.canSearchRecadvReceiver = false
      state.session.canRejectRecadv = false
      state.session.canModifyRecadv = false
      state.session.canCreateInvoiceRecadv = false
      state.session.canCreateInvoiceParcialRecadv = false
      state.session.canCheckStatus = false
      state.session.canViewAttach = false
      state.session.canChangeStatusRecadv = false
      state.session.cantViewRecadvPdf = false
      state.session.canSearchOrderSender = false
      state.session.canSearchOrderReceiver = false
      state.session.canChangeStatusOrder = false
      state.session.canCreateDeliveryNoteOrder = false
      state.session.canCreateInvoiceOrder = false
      state.session.canUploadInvoice = false
      state.session.canAdminUserAdvanced = false
      state.session.canNoEditUserData = false
      state.session.canViewMetadata = false
      state.session.canViewOrderMetadata = false
      state.session.canViewRecadvMetadata = false
      state.session.canViewOrderOriginal = false
      state.session.canViewRecadvOriginal = false
      state.session.canViewDesadvMetadata = false
      state.session.canViewDesadvOriginal = false
      state.session.canAttachmentHidden = false
      state.session.canViewRelationChannel = false
      state.session.canCreateIssue = false
      state.session.canSearchIssue = false
      state.session.canUpdateIssue = false
      state.session.canDeleteIssue = false
      state.session.canSearchDeliverySender = false
      state.session.canSearchDeliveryReceiver = false
      state.session.canChangeStatusDeliveryNote = false
      state.session.canCreateInvoiceDeliveryNote = false
      state.session.canSearchGenralSender = false
      state.session.canSearchGenralReceiver = false
      state.session.canSearchCMR = false
      state.session.canCreateCmrDraft = false
      state.session.canViewCmrDraftSellerCentres = false
      state.session.canViewCmrDraftBuyerCentres = false
      state.session.canEditCarrierCMR = false
      state.session.canEditChargerCMR = false
      state.session.canSearchSalesReportView = false
      state.session.canSearchInventoryReportView = false
      state.session.canSearchInventoryReport = false
      state.session.canSearchCoacsuView = false
      state.session.canSearchRemadvView = false
      state.session.canViewCoacsuMetadata = false
      state.session.canViewCoacsuOriginal = false
      state.session.canViewRemadvMetadata = false
      state.session.canViewRemadvOriginal = false
      state.session.canCreateCoacsu = false
      state.session.canViewSalesReportMetadata = false
      state.session.canViewSalesReportOriginal = false
      state.session.canViewInventoryReportMetadata = false
      state.session.canViewInventoryReportOriginal = false
      state.session.canAdminCentre = false
      state.session.canMultipleChangeStatus = false
    },

    // Datos constantes
    'COUNTRIES_LOADED' (state, payload) {
      state.local.countries = payload
    },
    'CONTRACTORS_LOADED' (state, payload) {
      state.local.contractors = payload
    },
    'INVOICE_STATUS_LOADED' (state, status) {
      state.local.invoiceStatus = status
    },

    // - Viejas - //
    'INVOICE_MODAL_STATE' (state, payload) {
      state.local.invoiceModal = payload
    },
    'SEARCH_BAR_TOGGLE_STATUS' (state, payload) {
      state.local.searchBarToggle = payload
    },
    'REMOVE_INVOICE_FILTER' (state, payload) {
      state.local.invoiceFilters[payload.name].results = ''
      state.local.invoiceFilters[payload.name].selected = payload.value
    },
    'ADD_INVOICE_FILTER' (state, payload) {
      axios.get(payload.url, {
        params: {
          [payload.name]: payload.value
        }
      })
        .then(response => {
          state.local.invoiceFilters[payload.name].counter = response.data.length
          state.local.invoiceFilters[payload.name].results = payload.value
          state.local.invoiceFilters[payload.name].selected = true
        })
    },
    'ADD_FILTERS_JSON' (state, payload) {
      state.local.invoiceFilters = payload
    },
    'FILTER_TABLE' (state, payload) {
      state.local.tableData = payload
    },
    'GET_TOTAL_RESULTS' (state, payload) {
      state.local.totalItemsTable = payload
    },
    'DISTINCT_COLUMN' (state, payload) {
      state.local.distinctColumnData = payload
    },
    'IS_SHOW_FACTURA' (state, payload) {
      state.local.isShowFactura = payload
    },
    'IS_SHOW_EMISION' (state, payload) {
      state.local.isShowEmision = payload
    },
    // Mutación no-op para forzar persistencia de session (flags permisos)
    'PERSIST_SESSION_FLAGS' () { /* no-op */ },
    'IS_SHOW_REGISTRO' (state, payload) {
      state.local.isShowRegistro = payload
    },
    'IS_SHOW_VENDEDOR' (state, payload) {
      state.local.isShowVendedor = payload
    },
    'IS_SHOW_COMPRADOR' (state, payload) {
      state.local.isShowComprador = payload
    },
    'IS_SHOW_IMPORTE' (state, payload) {
      state.local.isShowImporte = payload
    },
    'IS_SHOW_ESTADO' (state, payload) {
      state.local.isShowEstado = payload
    },
    // Set in the local
    'USER_CONFIG_SAVED' (state, payload) {
      if (localStorage.getItem(payload)) {
        const parseLocalStorage = JSON.parse(localStorage.getItem(payload))

        if (!parseLocalStorage.login || !parseLocalStorage.usuarios || !parseLocalStorage.activeLang || !parseLocalStorage.countries ||
          !parseLocalStorage.borradores || !parseLocalStorage.servicios || !parseLocalStorage.cierrescontables || !parseLocalStorage.recepciones ||
          !parseLocalStorage.pedidos || !parseLocalStorage.cierrescontablesBorradores || !parseLocalStorage.tareaspendientes || !parseLocalStorage.creacionFactura ||
          !parseLocalStorage.centros || !parseLocalStorage.facturas || !parseLocalStorage.issues || !parseLocalStorage.filtros || !parseLocalStorage.documentacion || !parseLocalStorage.auditorias ||
          !parseLocalStorage.auditoriaAcciones || !parseLocalStorage.profiles || !parseLocalStorage.plantillasdecorreo || !parseLocalStorage.estadistica || !parseLocalStorage.creacionAlbaran ||
          !parseLocalStorage.taxes || !parseLocalStorage.articles || !parseLocalStorage.mailServer || !parseLocalStorage.albaranes || !parseLocalStorage.genrals || !parseLocalStorage.procesosPlanificados || !parseLocalStorage.cmr ||
          !parseLocalStorage.ocrDocuments) {
          state.local = {
            ...state.local,
            ...parseLocalStorage,
            login: { ...state.local.login, ...parseLocalStorage.login },
            usuarios: { ...state.local.usuarios, ...parseLocalStorage.usuarios },
            borradores: { ...state.local.borradores, ...parseLocalStorage.borradores },
            servicios: { ...state.local.servicios, ...parseLocalStorage.servicios },
            cierrescontables: { ...state.local.cierrescontables, ...parseLocalStorage.cierrescontables },
            recepciones: { ...state.local.recepciones, ...parseLocalStorage.recepciones },
            pedidos: { ...state.local.pedidos, ...parseLocalStorage.pedidos },
            cierrescontablesBorradores: { ...state.local.cierrescontablesBorradores, ...parseLocalStorage.cierrescontablesBorradores },
            tareaspendientes: { ...state.local.tareaspendientes, ...parseLocalStorage.tareaspendientes },
            creacionFactura: { ...state.local.creacionFactura, ...parseLocalStorage.creacionFactura },
            creacionAlbaran: { ...state.local.creacionAlbaran, ...parseLocalStorage.creacionAlbaran },
            centros: { ...state.local.centros, ...parseLocalStorage.centros },
            facturas: { ...state.local.facturas, ...parseLocalStorage.facturas },
            issues: { ...state.local.issues, ...parseLocalStorage.issues },
            filtros: { ...state.local.filtros, ...parseLocalStorage.filtros },
            documentacion: { ...state.local.documentacion, ...parseLocalStorage.documentacion },
            auditorias: { ...state.local.auditorias, ...parseLocalStorage.auditorias },
            auditoriaAcciones: { ...state.local.auditoriaAcciones, ...parseLocalStorage.auditoriaAcciones },
            profiles: { ...state.local.profiles, ...parseLocalStorage.profiles },
            plantillasdecorreo: { ...state.local.plantillasdecorreo, ...parseLocalStorage.plantillasdecorreo },
            procesosPlanificados: { ...state.local.procesosPlanificados, ...parseLocalStorage.procesosPlanificados },
            taxes: { ...state.local.taxes, ...parseLocalStorage.taxes },
            articles: { ...state.local.articles, ...parseLocalStorage.articles },
            mailServer: { ...state.local.mailServer, ...parseLocalStorage.mailServer },
            estadistica: { ...state.local.estadistica, ...parseLocalStorage.estadistica },
            albaranes: { ...state.local.albaranes, ...parseLocalStorage.albaranes },
            genrals: { ...state.local.genrals, ...parseLocalStorage.genrals },
            cmr: { ...state.local.cmr, ...parseLocalStorage.cmr },
            countries: state.local.countries,
            activeLang: state.local.activeLang,
            salesReport: { ...state.local.salesReport, ...parseLocalStorage.salesReport },
            inventoryReport: { ...state.local.inventoryReport, ...parseLocalStorage.inventoryReport },
            remadv: { ...state.local.remadv, ...parseLocalStorage.remadv },
            coacsu: { ...state.local.coacsu, ...parseLocalStorage.coacsu }
          }
        } else {
          if (parseLocalStorage.activeLang !== state.local.activeLang) {
            parseLocalStorage.activeLang = state.local.activeLang
          }
          if (parseLocalStorage.countries.length === 0) {
            parseLocalStorage.countries = state.local.countries
          }
          state.local = parseLocalStorage
        }
      } else {
        state.local.login = state.login.local
        state.local.usuarios = state.usuarios.local
        state.local.borradores = state.borradores.local
        state.local.servicios = state.servicios.local
        state.local.cierrescontables = state.cierrescontables.local
        state.local.recepciones = state.recepciones.local
        state.local.pedidos = state.pedidos.local
        state.local.cierrescontablesBorradores = state.cierrescontablesBorradores.local
        state.local.profile = state.profile.local
        state.local.profiles = state.profiles.local
        state.local.taxes = state.taxes.local
        state.local.articles = state.articles.local
        state.local.mailServer = state.mailServer.local
        state.local.tareaspendientes = state.tareaspendientes.local
        state.local.creacionFactura = state.creacionFactura.local
        state.local.creacionAlbaran = state.creacionAlbaran.local
        state.local.centros = state.centros.local
        state.local.facturas = state.facturas.local
        state.local.issues = state.issues.local
        state.local.filtros = state.filtros.local
        state.local.documentacion = state.documentacion.local
        state.local.auditorias = state.auditorias.local
        state.local.auditoriaAcciones = state.auditoriaAcciones.local
        state.local.plantillasdecorreo = state.plantillasdecorreo.local
        state.local.procesosPlanificados = state.procesosPlanificados.local
        state.local.estadistica = state.estadistica.local
        state.local.albaranes = state.albaranes.local
        state.local.genrals = state.genrals.local
        state.local.cmr = state.cmr.local
        state.local.ocrDocuments = state.ocrDocuments.local
      }
      localStorage.setItem('local', JSON.stringify(state.local))
      localStorage.setItem(payload, JSON.stringify(state.local))
    }
  },

  actions: {
    // Crear key Usuario
    B2bCreateConfig ({ state, commit }) {
      // Manda el username a las computadas para su comprobacion en el storage
      const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
      if (B2bUserConfigSession.activeUser.data) {
        state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
        commit('USER_CONFIG_SAVED', B2bUserConfigSession.activeUser.data.username)
      }
    },
    // Funcion para resetear el sessionStorage cuando se hace logout.
    // IMPORTANTE incluir cada uno de los modules que contengan datos de sesión
    resetSession ({ state, commit }) {
      // Guardar el idioma antes de resetear
      let savedLang = null;
      if (state.local?.activeLang) {
        savedLang = state.local.activeLang;
      } else {
        // Intentar recuperar de localStorage si existe
        try {
          const local = JSON.parse(localStorage.getItem('local'));
          if (local?.activeLang) savedLang = local.activeLang;
        } catch (e) {
          console.log('error', e)
        }
      }

      state.session = initSession();
      state.session.usuarios = commit('resetSessionUsuarios');
      state.session.borradores = commit('resetSessionBorradores');
      state.session.servicios = commit('resetSessionServicios');
      state.session.cierrescontables = commit('resetSessionCierresContables');
      state.session.recepciones = commit('resetSessionRecepciones');
      state.session.pedidos = commit('resetSessionPedidos');
      state.session.cierrescontablesBorradores = commit('resetSessionCierresContablesBorradores');
      state.session.profile = commit('resetSessionProfile');
      state.session.profiles = commit('resetSessionProfiles');
      state.session.tareaspendientes = commit('resetSessionTareasPendientes');
      state.session.taxes = commit('resetSessionTaxes');
      state.session.mailServer = commit('resetSessionMailServer');
      state.session.creacionFactura = commit('resetSessionCreacionFactura');
      state.session.creacionAlbaran = commit('resetSessionCreacionAlbaran');
      state.session.centros = commit('resetSessionCentros');
      state.session.facturas = commit('resetSessionFacturas');
      state.session.issues = commit('resetSessionIssues');
      state.session.filtros = commit('resetSessionFiltros');
      state.session.documentacion = commit('resetSessionDocumentacion');
      state.session.auditorias = commit('resetSessionAuditorias');
      state.session.auditoriaAcciones = commit('resetSessionAuditoriaAcciones');
      state.session.procesosPlanificados = commit('resetSessionPlannedProcesses');
      state.session.estadistica = commit('resetSessionEstadistica');
      state.session.albaranes = commit('resetSessionAlbaranes');
      state.session.genrals = commit('resetSessionGenrals');
      state.session.cmr = commit('resetSessionCmr');
      state.session.ocrDocuments = commit('resetSessionOcrDocuments');
      state.session.articles = commit('resetSessionArticles');

      // Restaurar el idioma después del reset
      if (savedLang) {
        if (!state.local) state.local = {};
        state.local.activeLang = savedLang;
        // Guardar en localStorage
        try {
          const local = localStorage.getItem('local') ? JSON.parse(localStorage.getItem('local')) : {};
          local.activeLang = savedLang;
          localStorage.setItem('local', JSON.stringify(local));
        } catch (e) {
          console.log('error', e)
        }
      }
    },

    // Funcion para definir el filtro rápido de fechas cuando se es superadmin
    datesSuperAdmin ({ state, commit }) {
      commit('auditsDatesSUperAdmin')
      commit('emittedPayrollsDatesSuperAdmin')
      commit('receivedPayrollsDatesSuperAdmin')
      commit('draftDatesSuperAdmin')
      commit('accountingCloseDatesSuperAdmin')
      commit('recadvDatesSuperAdmin')
      commit('draftAccountingCloseDatesSuperAdmin')
      commit('pendingTaskDatesSuperAdmin')
      commit('centresDatesSuperAdmin')
    },

    async isNewVersionLocalState ({ state, dispatch }, localStorage) {
      const isNewVersionLocalObject = isNewVersion(state, localStorage)
      const isNewVersionLoginLocalObject = await dispatch('isNewVersionLoginLocalState', localStorage)
      const isNewVersionUsuariosLocalObject = await dispatch('isNewVersionUsuariosLocalState', localStorage)
      const isNewVersionBorradoresLocalObject = await dispatch('isNewVersionBorradoresLocalState', localStorage)
      const isNewVersionServiciosLocalObject = await dispatch('isNewVersionServiciosLocalState', localStorage)

      const isNewVersionAuditoriaAccionesLocalObject = await dispatch('isNewVersionAuditoriaAccionesLocalState', localStorage)
      const isNewVersionPlantillasDeCorreoLocalObject = await dispatch('isNewVersionPlantillasDeCorreoLocalState', localStorage)
      const isNewVersionProcesosPlanificadosLocalObject = await dispatch('isNewVersionProcesosPlanificadosLocalState', localStorage)
      const isNewVersionRecepcionesLocalObject = await dispatch('isNewVersionRecepcionesLocalState', localStorage)
      const isNewVersionPedidosLocalObject = await dispatch('isNewVersionPedidosLocalState', localStorage)
      const isNewVersionCierresContablesLocalObject = await dispatch('isNewVersionCierresContablesLocalState', localStorage)
      const isNewVersionCierresContablesBorradoresLocalObject = await dispatch('isNewVersionCierresContablesBorradoresLocalState', localStorage)
      const isNewVersionProfileLocalObject = await dispatch('isNewVersionProfileLocalState', localStorage)
      const isNewVersionProfilesLocalObject = await dispatch('isNewVersionProfilesLocalState', localStorage)
      const isNewVersionTaxesLocalObject = await dispatch('isNewVersionTaxesLocalState', localStorage)
      const isNewVersionMailServerLocalObject = await dispatch('isNewVersionMailServerLocalState', localStorage)
      const isNewVersionArticlesLocalObject = await dispatch('isNewVersionArticlesLocalState', localStorage)

      const isNewVersionTareasPendientesLocalObject = await dispatch('isNewVersionTareasPendientesLocalState', localStorage)
      const isNewVersionCreacionFacturaLocalObject = await dispatch('isNewVersionCreacionFacturaLocalState', localStorage)
      const isNewVersionCreacionAlbaranLocalObject = await dispatch('isNewVersionCreacionAlbaranLocalState', localStorage)
      const isNewVersionCentrosLocalObject = await dispatch('isNewVersionCentrosLocalState', localStorage)
      const isNewVersionFacturasLocalObject = await dispatch('isNewVersionFacturasLocalState', localStorage)
      const isNewVersionIssuesLocalObject = await dispatch('isNewVersionIssuesLocalState', localStorage)
      const isNewVersionFiltrosLocalObject = await dispatch('isNewVersionFiltrosLocalState', localStorage)
      const isNewVersionDocumentacionLocalObject = await dispatch('isNewVersionDocumentacionLocalState', localStorage)
      const isNewVersionEstadisticaLocalObject = await dispatch('isNewVersionEstadisticaLocalState', localStorage)
      const isNewVersionAlbaranesLocalObject = await dispatch('isNewVersionAlbaranesLocalState', localStorage)
      const isNewVersionGenralsLocalObject = await dispatch('isNewVersionGenralsLocalState', localStorage)
      const isNewVersionCmrLocalObject = await dispatch('isNewVersionCmrLocalState', localStorage)
      const isNewVersionOcrDocumentsLocalObject = await dispatch('isNewVersionOcrDocumentsLocalState', localStorage)

      const isNewVersionAuditoriasLocalObject = await dispatch('isNewVersionAuditoriasLocalState', localStorage)
      return isNewVersionLoginLocalObject || isNewVersionLocalObject || isNewVersionBorradoresLocalObject ||
        isNewVersionCentrosLocalObject || isNewVersionUsuariosLocalObject || isNewVersionServiciosLocalObject ||
        isNewVersionRecepcionesLocalObject || isNewVersionPedidosLocalObject || isNewVersionCierresContablesLocalObject || isNewVersionCierresContablesBorradoresLocalObject ||
        isNewVersionProfilesLocalObject || isNewVersionProfileLocalObject || isNewVersionTareasPendientesLocalObject || isNewVersionCreacionFacturaLocalObject ||
        isNewVersionCreacionAlbaranLocalObject || isNewVersionFacturasLocalObject || isNewVersionIssuesLocalObject || isNewVersionFiltrosLocalObject ||
        isNewVersionDocumentacionLocalObject || isNewVersionAuditoriasLocalObject || isNewVersionAuditoriaAccionesLocalObject ||
        isNewVersionPlantillasDeCorreoLocalObject || isNewVersionEstadisticaLocalObject || isNewVersionAlbaranesLocalObject || isNewVersionGenralsLocalObject ||
        isNewVersionTaxesLocalObject || isNewVersionArticlesLocalObject || isNewVersionMailServerLocalObject || isNewVersionProcesosPlanificadosLocalObject || isNewVersionCmrLocalObject ||
        isNewVersionOcrDocumentsLocalObject
    },

    // Detalles de usuario por username
    async getUserByUsername ({ commit, rootState }, data) {
      try {
        const response = await axios({
          method: 'GET',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: '/me/username',
          params: {
            username: data
          }
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        throw error.response
      }
    },

    changeActiveLangState: ({
      commit, state
    }, lang) => {
      // i18n.locale = lang
      i18n.global.locale = lang

      commit('ACTIVE_LANG_STATE', lang)
      if (lang) {
        axios.defaults.headers.common['Accept-Language'] = lang
      }
      const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
      if (B2bUserConfigSession.activeUser.data) {
        state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
        commit('USER_CONFIG_SAVED', B2bUserConfigSession.activeUser.data.username)
      }
    },

    // Usuario
    activeUserState: ({
      commit
    }, payload) => {
      commit('ACTIVE_USER_STATE', payload)
    },
    jwtState: ({
      commit
    }, payload) => {
      commit('JWT_STATE', payload)
    },
    urlInState: ({
      commit
    }, payload) => {
      commit('URL_IN_STATE', payload)
    },
    primaryColorState: ({
      commit
    }, payload) => {
      commit('PRIMARY_COLOR_STATE', payload)
    },
    secondaryColorState: ({
      commit
    }, payload) => {
      commit('SECONDARY_COLOR_STATE', payload)
    },
    clientbgState: ({
      commit
    }, payload) => {
      commit('CLIENTBG_COLOR_STATE', payload)
    },
    recoveryPassUserState: ({
      commit
    }, payload) => {
      commit('RECOVERY_PASS_USER_STATE', payload)
    },
    //* - VIEJAS -//
    getJsonFiltersData: ({
      commit
    }, payload) => {
      commit('ADD_FILTERS_JSON', payload)
    },
    invoiceModalState: ({
      commit
    }, payload) => {
      commit('INVOICE_MODAL_STATE', payload)
    },
    searchBarToggleStatus: ({
      commit
    }, payload) => {
      commit('SEARCH_BAR_TOGGLE_STATUS', payload)
    },
    removeInvoiceFilter: ({
      commit
    }, payload) => {
      commit('REMOVE_INVOICE_FILTER', payload)
    },
    addInvoiceFilter: ({
      commit
    }, payload) => {
      commit('ADD_INVOICE_FILTER', payload)
    },
    filterTable: ({
      commit, state
    }, payload) => {
      const newParams = { ...payload.params, ...payload.filters}
      return new Promise((resolve) => {
        axios.get(payload.url, {
          params: newParams
        }).then((response) => {
          commit('FILTER_TABLE', response.data)
          resolve()
        }).catch(e => {
          state.ERRORS.push(e)
        })
      })
    },
    getTotalResults: ({
      commit, state
    }, payload) => {
      return new Promise((resolve) => {
        axios.get(payload.url, {
          params: payload.filters
        })
          .then(response => {
            commit('GET_TOTAL_RESULTS', response.data.length)
            resolve()
          }).catch(e => {
            state.ERRORS.push(e)
          })
      })
    },
    isShowFactura: ({
      commit
    }, payload) => {
      commit('IS_SHOW_FACTURA', payload)
    },
    isShowEmision: ({
      commit
    }, payload) => {
      commit('IS_SHOW_EMISION', payload)
    },
    isShowRegistro: ({
      commit
    }, payload) => {
      commit('IS_SHOW_REGISTRO', payload)
    },
    isShowVendedor: ({
      commit
    }, payload) => {
      commit('IS_SHOW_VENDEDOR', payload)
    },
    isShowComprador: ({
      commit
    }, payload) => {
      commit('IS_SHOW_COMPRADOR', payload)
    },
    isShowImporte: ({
      commit
    }, payload) => {
      commit('IS_SHOW_IMPORTE', payload)
    },
    isShowEstado: ({
      commit
    }, payload) => {
      commit('IS_SHOW_ESTADO', payload)
    },
    getDistinctColumn: ({
      commit,
      state
    }, payload) => {
      const lookup = {}
      const result = []
      return new Promise((resolve) => {
        for (var item, i = 0; item = state.tableData[i++];) { // eslint-disable-line
          const name = item[payload]

          if (!(name in lookup)) {
            lookup[name] = 1
            const newObject = {
              name: name,
              value: name,
              selected: false
            }
            result.push(newObject)
          }
        }
        commit('DISTINCT_COLUMN', result)
        resolve()
      })
    },

    // Facturas
    // Constantes
    getCountries ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'GET',
          url: '/constant/country',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })
          .then(response => {
            fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
            commit('COUNTRIES_LOADED', response.data)
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            resolve([])
            commit('COUNTRIES_LOADED', [])
          })
      })
    },

    getContractors ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'GET',
          url: '/constant/contractor',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })
          .then(response => {
            fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
            commit('CONTRACTORS_LOADED', response.data)
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            resolve([])
            commit('CONTRACTORS_LOADED', [])
          })
      })
    },

    // PERMISOS (versión con resolve y null-safety)
    parseUserAuthorities ({ state, commit }) {
      const auths = (state.session.activeUser?.data && Array.isArray(state.session.activeUser.data.authorities)) ? state.session.activeUser.data.authorities : []
      return new Promise((resolve) => {
        const has = (p) => auths.includes(p)
        state.session.canCreateServices = has('CREATE_PROJECT')
        state.session.canCreateParty = has('CREATE_PARTY')
        state.session.canCreateCentre = has('CREATE_CENTRE')
        state.session.canAdminIndra = has('ADMIN_INDRA')
        state.session.canModifyProject = has('MODIFY_PROJECT')
        state.session.canEditProjectDeliveryMethod = has('PROJEC_DELIVERY_METHOD')
        state.session.canEditPartyDeliveryMethod = has('PARTY_DELIVERY_METHOD')
        state.session.canViewComercialRelation = has('VIEW_COMERCIAL_RELATION')
        state.session.canCreateComercialRelation = has('CREATE_COMERCIAL_RELATION')
        state.session.canAdminProject = has('ADMIN_PROJECT')
        state.session.canAdminParty = has('ADMIN_PARTY')
        state.session.canAdminUser = has('ADMIN_USER')
        state.session.canAdminPartyAdvanced = has('ADVANCED_ADMIN_PARTY')
        state.session.canViewBankData = has('VIEW_BANK_DATA')
        state.session.canAdminProfile = has('ADMIN_PROFILE')
        state.session.canAdminProfiles = has('ADMIN_PROFILE')
        state.session.canAdminTaxes = has('ADMIN_TAX')
        state.session.canAdminArticle = has('ADMIN_ARTICLE')
        state.session.canAdminMethods = has('ADMIN_METHODS')
        state.session.canAdminQuartz = has('ADMIN_QUARTZ')
        state.session.canAdminDocumentation = has('ADMIN_DOCUMENTATION')
        state.session.canChangePartyMedia = has('CHANGE_PARTY_MEDIA')
        state.session.canModifyPaymentMethods = has('MODIFY_PAYMENT_METHODS')
        state.session.canViewDistributionCentres = has('VIEW_DISTRIBUTION_CENTRES')
        state.session.canChangeCentreRoles = has('CHANGE_CENTRE_ROLE')
        state.session.canEditOrDeleteCentreWithPermanentEstablishment = has('EDIT_CENTRE_PERMANENT_ESTABLISHMENT')
        state.session.canAdminApprovalFlowByLevels = has('ADMIN_APPROVAL_FLOW_BY_LEVELS')
        state.session.canUserApprovalFlowByLevels = has('USER_APPROVAL_FLOW_BY_LEVELS')
        state.session.canViewMenu = has('VIEW_MENU')
        state.session.canSearchInvoiceSales = has('SEARCH_INVOICE_SALES')
        state.session.canSearchInvoicePurchases = has('SEARCH_INVOICE_PURCHASES')
        state.session.canSearchInvoiceThird = has('SEARCH_INVOICE_THIRD')
        state.session.canSearchReportEmitted = has('SEARCH_REPORT_EMITTED')
        state.session.canSearchReportReceived = has('SEARCH_REPORT_RECEIVED')
        state.session.canSearchInvoiceDraft = has('SEARCH_INVOICE_DRAFT')
        state.session.canCreateInvoiceDraft = has('CREATE_INVOICE_DRAFT')
        state.session.canCopyInvoiceDraft = has('COPY_INVOICE')
        state.session.canSearchAccountingClose = has('SEARCH_ACCOUNTING_CLOSE')
        state.session.canSearchAccountingCloseDraft = has('SEARCH_ACCOUNTING_CLOSE_DRAFT')
        state.session.canSearchPendingTasks = has('SEARCH_PENDING_TASKS')
        state.session.canSearchOcrDocuments = has('SEARCH_OCR_DOCUMENTS')
        state.session.canSeeSingDocument = has('CONSULT_SIGNDOCUMENT')
        state.session.canDeleteSingDocument = has('DELETE_SIGNDOCUMENT')
        state.session.canAddSingDocument = has('UPLOAD_SIGNDOCUMENT')
        state.session.canResendEmittedInvoices = has('FORWARD_INVOICE_EMITTED')
        state.session.canResendReceivedInvoices = has('FORWARD_INVOICE_RECEIVED')
        state.session.canCreateCover = has('CREATE_COVER')
        state.session.canAddBuyerCenter = has('ADD_BUYER_CENTRE')
        state.session.canEditInvoices = has('EDIT_INVOICE_DATA')
        state.session.canEditInternalNotes = has('EDIT_INVOICE_NOTE')
        state.session.canViewInternalNotes = has('VIEW_INVOICE_NOTE')
        state.session.canAddAttachments = has('ADD_INVOICE_ATTACHMENTS')
        state.session.canSeeAttachments = has('VIEW_INVOICE_ATTACHMENT')
        state.session.canSeeEvents = has('VIEW_INVOICE_EVENTS')
        state.session.canSeeDocuments = has('VIEW_INVOICE_DOCUMENTS')
        state.session.canGetPaymentData = has('GET_PAYMENT_DATA')
        state.session.canSeeEventsBpm = has('VIEW_INVOICE_BPM_EVENTS')
        state.session.canDeleteAttachments = has('DELETE_INVOICE_ATTACHMENTS')
        state.session.canSearchChannel = has('SEARCH_CHANNEL')
        state.session.canCancelInvoice = has('CANCEL_INVOICE')
        state.session.canChangeStatusPendingTask = has('CHANGE_STATUS_PENDINGTASKS')
        state.session.canChangeStatusInvoice = has('CHANGE_INVOICE_STATUS')
        state.session.canChangeSentFlagInvoice = has('ADMIN_INDRA')
        state.session.canViewRequestDigitalization = has('VIEW_REQUEST_REDIGITALIZATION')
        state.session.canDownloadFormatted = has('DOWNLOAD_INVOIC_FORMATTED')
        state.session.canViewStatusColor = has('VIEW_INVALID_INVOICE_COLOR')
        state.session.canCreateDraftFromRecadv = has('CREATE_INVOICE_FROM_RECADV')
        state.session.canCreateCorrectiveInvoice = has('CREATE_CORRECTIVE_INVOICE')
        state.session.cantViewInvoiceSeriesCode = has('NO_VIEW_INVOICE_SERIES_CODE')
        state.session.canViewTotalIrpf = has('TOTAL_IRPF')
        state.session.canSearchDocumentAuditory = has('AUDITORY_DOCUMENT')
        state.session.canSearchActionAuditory = has('AUDITORY_ACTION')
        state.session.canConsultDocumentation = has('CONSULT_DOCUMENTATION')
        state.session.canConsulStatistics = has('STATISTICS_MANAGEMENT')
        state.session.canSearchRecadvSender = has('SEARCH_RECADV_SENDER')
        state.session.canSearchRecadvReceiver = has('SEARCH_RECADV_RECEIVER')
        state.session.canRejectRecadv = has('REJECT_RECADV')
        state.session.canModifyRecadv = has('MODIFY_RECADV')
        state.session.canCreateInvoiceRecadv = has('RECADV_CREATE_INVOICE')
        state.session.canCreateInvoiceParcialRecadv = has('RECADV_CREATE_INVOICE_PARCIAL')
        state.session.canCheckStatus = has('CHECK_STATUS')
        state.session.canViewAttach = has('RECADV_ATTACH')
        state.session.canChangeStatusRecadv = has('CHANGE_STATUS_RECADV')
        state.session.cantViewRecadvPdf = has('NO_VIEW_RECADV_PDF')
        state.session.canSearchOrderSender = has('SEARCH_ORDER_SENDER')
        state.session.canSearchOrderReceiver = has('SEARCH_ORDER_RECEIVER')
        state.session.canChangeStatusOrder = has('CHANGE_STATUS_ORDER')
        state.session.canCreateDeliveryNoteOrder = has('ORDER_CREATE_DELIVERY_NOTE')
        state.session.canCreateInvoiceOrder = has('ORDER_CREATE_INVOICE')
        state.session.canUploadInvoice = has('UPLOAD_INVOICE')
        state.session.canAdminUserAdvanced = has('ADVANCED_ADMIN_USER')
        state.session.canNoEditUserData = has('NO_EDIT_DATA_USER')
        state.session.canViewMetadata = has('VIEW_METADATA')
        state.session.canViewOrderMetadata = has('VIEW_ORDER_METADATA')
        state.session.canViewRecadvMetadata = has('VIEW_RECADV_METADATA')
        state.session.canViewOrderOriginal = has('VIEW_ORDER_ORIGINAL')
        state.session.canViewRecadvOriginal = has('VIEW_RECADV_ORIGINAL')
        state.session.canViewDesadvMetadata = has('VIEW_DESADV_METADATA')
        state.session.canViewDesadvOriginal = has('VIEW_DESADV_ORIGINAL')
        state.session.canAttachmentHidden = has('ATTACHMENT_HIDDEN')
        state.session.canViewRelationChannel = has('VIEW_RELATION_CHANNEL')
        state.session.canCreateIssue = has('CREATE_ISSUE')
        state.session.canSearchIssue = has('SEARCH_ISSUE')
        state.session.canUpdateIssue = has('UPDATE_ISSUE')
        state.session.canDeleteIssue = has('DELETE_ISSUE')
        state.session.canSearchDeliverySender = has('SEARCH_DELIVERY_SENDER')
        state.session.canSearchDeliveryReceiver = has('SEARCH_DELIVERY_RECEIVER')
        state.session.canChangeStatusDeliveryNote = has('CHANGE_STATUS_DELIVERYNOTE')
        state.session.canCreateInvoiceDeliveryNote = has('CREATE_INVOICE_FROM_DELIVERY_NOTE')
        state.session.canSearchGenralSender = has('SEARCH_GENRAL_SENDER')
        state.session.canSearchGenralReceiver = has('SEARCH_GENRAL_RECEIVER')
        state.session.canSearchCMR = has('VIEW_CMR')
        state.session.canCreateCmrDraft = has('CREATE_CMR_DRAFT')
        state.session.canViewCmrDraftSellerCentres = has('VIEW_CMR_DRAFT_SELLER_CENTRES')
        state.session.canViewCmrDraftBuyerCentres = has('VIEW_CMR_DRAFT_BUYER_CENTRES')
        state.session.canEditCarrierCMR = has('EDIT_CARRIER_CMR')
        state.session.canEditChargerCMR = has('EDIT_CHARGER_CMR')
        state.session.canSearchSalesReportView = has('SEARCH_SALES_REPORT_VIEW')
        state.session.canSearchInventoryReportView = has('SEARCH_INVENTORY_REPORT_VIEW')
        // Alias para mantener compatibilidad con getter existente (canSearchInventoryReport)
        state.session.canSearchInventoryReport = state.session.canSearchInventoryReportView
        // Nuevos COACSU / REMADV
        state.session.canSearchCoacsuView = has('SEARCH_COACSU_VIEW')
        state.session.canSearchRemadvView = has('SEARCH_REMADV_VIEW')
        state.session.canViewCoacsuMetadata = has('VIEW_COACSU_METADATA')
        state.session.canViewCoacsuOriginal = has('VIEW_COACSU_ORIGINAL')
        state.session.canViewRemadvMetadata = has('VIEW_REMADV_METADATA')
        state.session.canViewRemadvOriginal = has('VIEW_REMADV_ORIGINAL')
        state.session.canCreateCoacsu = has('CREATE_COACSU')
        // Reporte de Ventas (metadata / original)
        state.session.canViewSalesReportMetadata = has('VIEW_SALES_REPORT_METADATA')
        state.session.canViewSalesReportOriginal = has('VIEW_SALES_REPORT_ORIGINAL')
        // Reporte de Inventario (metadata / original)
        state.session.canViewInventoryReportMetadata = has('VIEW_INVENTORY_REPORT_METADATA')
        state.session.canViewInventoryReportOriginal = has('VIEW_INVENTORY_REPORT_ORIGINAL')
        // Administración de centro y cambio múltiple de estados
        state.session.canAdminCentre = has('ADMIN_CENTRE')
        state.session.canMultipleChangeStatus = has('MULTIPLE_CHANGE_STATUS')
        // Garantizar que el flag de menú no se pierda (fallback defensivo)
        if (!state.session.canViewMenu && has('VIEW_MENU')) { state.session.canViewMenu = true }
        // Forzar persistencia (dispara subscribe y guarda en sessionStorage)
        commit('PERSIST_SESSION_FLAGS')
        resolve()
      })
    }

  },

  getters: {
    // NUEVOS
    getActiveLang: state => {
      return state.local.activeLang
    },
    // Usuario
    activeUser: state => {
      return state.session.activeUser
    },
    jwt: state => {
      return state.session.jwt
    },
    urlIn: state => {
      return state.session.urlIn
    },
    primaryColor: state => {
      return state.session.primaryColor
    },
    secondaryColor: state => {
      return state.session.secondaryColor
    },
    clientbg: state => {
      return state.session.clientbg
    },
    recoveryPassUser: state => {
      return state.session.recoveryPassUser
    },

    // Datos Tablas Facturas Emitidas
    invoice: state => {
      return state.local.invoice
    },

    // Constantes
    countries: state => {
      return state.local.countries
    },
    contractors: state => {
      return state.local.contractors
    },
    invoiceStatus: state => {
      return state.local.invoiceStatus
    },

    // FLAGS de permisos
    /* ADMIN */
    canCreateServices: state => {
      return state.session.canCreateServices
    },
    canCreateParty: state => {
      return state.session.canCreateParty
    },
    canCreateCentre: state => {
      return state.session.canCreateCentre
    },
    canAdminIndra: state => {
      return state.session.canAdminIndra
    },
    canModifyProject: state => {
      return state.session.canModifyProject
    },
    canEditProjectDeliveryMethod: state => {
      return state.session.canEditProjectDeliveryMethod
    },
    canEditPartyDeliveryMethod: state => {
      return state.session.canEditPartyDeliveryMethod
    },
    canViewComercialRelation: state => {
      return state.session.canViewComercialRelation
    },
    canCreateComercialRelation: state => {
      return state.session.canCreateComercialRelation
    },
    canAdminProject: state => {
      return state.session.canAdminProject
    },
    canAdminParty: state => {
      return state.session.canAdminParty
    },
    canAdminCentre: state => {
      return state.session.canAdminCentre
    },
    canChangePartyMedia: state => {
      return state.session.canChangePartyMedia
    },
    canModifyPaymentMethods: state => {
      return state.session.canModifyPaymentMethods
    },
    canAdminUser: state => {
      return state.session.canAdminUser
    },
    canAdminPartyAdvanced: state => {
      return state.session.canAdminPartyAdvanced
    },
    canAdminProfile: state => {
      return state.session.canAdminProfile
    },
    canAdminProfiles: state => {
      return state.session.canAdminProfiles
    },
    canAdminTaxes: state => {
      return state.session.canAdminTaxes
    },
    canAdminArticle: state => {
      return state.session.canAdminArticle
    },
    canAdminMethods: state => {
      return state.session.canAdminMethods
    },
    canAdminQuartz: state => {
      return state.session.canAdminQuartz
    },
    canAdminDocumentation: state => {
      return state.session.canAdminDocumentation
    },

    canViewBankData: state => {
      return state.session.canViewBankData
    },

    canViewDistributionCentres: state => {
      return state.session.canViewDistributionCentres
    },
    canChangeCentreRoles: state => {
      return state.session.canChangeCentreRoles
    },
    canEditOrDeleteCentreWithPermanentEstablishment: state => {
      return state.session.canEditOrDeleteCentreWithPermanentEstablishment
    },
    canAdminApprovalFlowByLevels: state => {
      return state.session.canAdminApprovalFlowByLevels
    },
    canUserApprovalFlowByLevels: state => {
      return state.session.canUserApprovalFlowByLevels
    },
    /* MENU */
    canViewMenu: state => {
      return state.session.canViewMenu
    },
    /* PAYROLL */
    canSearchInvoiceSales: state => {
      return state.session.canSearchInvoiceSales
    },
    canSearchReportEmitted: state => {
      return state.session.canSearchReportEmitted
    },
    canSearchReportReceived: state => {
      return state.session.canSearchReportReceived
    },
    canSearchInventoryReport: state => {
      return state.session.canSearchInventoryReport || state.session.canSearchInventoryReportView
    },
    canSearchInvoicePurchases: state => {
      return state.session.canSearchInvoicePurchases
    },
    canSearchInvoiceThird: state => {
      return state.session.canSearchInvoiceThird
    },
    /* DRAFT */
    canSearchInvoiceDraft: state => {
      return state.session.canSearchInvoiceDraft
    },
    canCreateInvoiceDraft: state => {
      return state.session.canCreateInvoiceDraft
    },
    canCopyInvoiceDraft: state => {
      return state.session.canCopyInvoiceDraft
    },
    /* ACCOUNTING CLOSE */
    canSearchAccountingClose: state => {
      return state.session.canSearchAccountingClose
    },
    canSearchAccountingCloseDraft: state => {
      return state.session.canSearchAccountingCloseDraft
    },
    /* PENDING TASK */
    canSearchPendingTasks: state => {
      return state.session.canSearchPendingTasks
    },
    canMultipleChangeStatus: state => {
      return state.session.canMultipleChangeStatus
    },
    /* OCR - DOCUMENTOS PENDIENTES DE VALIDAR */
    canSearchOcrDocuments: state => {
      return state.session.canSearchOcrDocuments
    },
    /* DOCUMENT */
    canSeeSingDocument: state => {
      return state.session.canSeeSingDocument
    },
    canDeleteSingDocument: state => {
      return state.session.canDeleteSingDocument
    },
    canAddSingDocument: state => {
      return state.session.canAddSingDocument
    },
    /* INVOICE */
    canResendEmittedInvoices: state => {
      return state.session.canResendEmittedInvoices
    },
    canResendReceivedInvoices: state => {
      return state.session.canResendReceivedInvoices
    },
    canCreateCover: state => {
      return state.session.canCreateCover
    },
    canAddBuyerCenter: state => {
      return state.session.canAddBuyerCenter
    },
    canEditInvoices: state => {
      return state.session.canEditInvoices
    },
    canEditInternalNotes: state => {
      return state.session.canEditInternalNotes
    },
    canViewInternalNotes: state => {
      return state.session.canViewInternalNotes
    },
    canAddAttachments: state => {
      return state.session.canAddAttachments
    },
    canSeeAttachments: state => {
      return state.session.canSeeAttachments
    },
    canSeeEvents: state => {
      return state.session.canSeeEvents
    },
    canSeeDocuments: state => {
      return state.session.canSeeDocuments
    },
    canGetPaymentData: state => {
      return state.session.canGetPaymentData
    },
    canSeeEventsBpm: state => {
      return state.session.canSeeEventsBpm
    },
    canDeleteAttachments: state => {
      return state.session.canDeleteAttachments
    },
    canSearchChannel: state => {
      return state.session.canSearchChannel
    },
    canCancelInvoice: state => {
      return state.session.canCancelInvoice
    },
    canChangeStatusPendingTask: state => {
      return state.session.canChangeStatusPendingTask
    },
    canChangeStatusInvoice: state => {
      return state.session.canChangeStatusInvoice
    },
    canChangeSentFlagInvoice: state => {
      return state.session.canChangeSentFlagInvoice
    },
    canViewRequestDigitalization: state => {
      return state.session.canViewRequestDigitalization
    },
    canDownloadFormatted: state => {
      return state.session.canDownloadFormatted
    },
    canViewStatusColor: state => {
      return state.session.canViewStatusColor
    },
    canCreateDraftFromRecadv: state => {
      return state.session.canCreateDraftFromRecadv
    },
    canCreateCorrectiveInvoice: state => {
      return state.session.canCreateCorrectiveInvoice
    },
    cantViewInvoiceSeriesCode: state => {
      return state.session.cantViewInvoiceSeriesCode
    },
    cantValidateOperationDate: state => {
      return state.session.cantValidateOperationDate
    },
    canViewTotalIrpf: state => {
      return state.session.canViewTotalIrpf
    },
    /* AUDITORY */
    canSearchDocumentAuditory: state => {
      return state.session.canSearchDocumentAuditory
    },
    canSearchActionAuditory: state => {
      return state.session.canSearchActionAuditory
    },
    /* DOCUMENTATION */
    canConsultDocumentation: state => {
      return state.session.canConsultDocumentation
    },
    /* STATISTICS */
    canConsulStatistics: state => {
      return state.session.canConsulStatistics
    },
    /* RECADV */
    canSearchRecadvSender: state => {
      return state.session.canSearchRecadvSender
    },
    canSearchRecadvReceiver: state => {
      return state.session.canSearchRecadvReceiver
    },
    canRejectRecadv: state => {
      return state.session.canRejectRecadv
    },
    canModifyRecadv: state => {
      return state.session.canModifyRecadv
    },
    canCreateInvoiceRecadv: state => {
      return state.session.canCreateInvoiceRecadv
    },
    canCreateInvoiceParcialRecadv: state => {
      return state.session.canCreateInvoiceParcialRecadv
    },
    canViewAttach: state => {
      return state.session.canViewAttach
    },
    canChangeStatusRecadv: state => {
      return state.session.canChangeStatusRecadv
    },
    cantViewRecadvPdf: state => {
      return state.session.cantViewRecadvPdf
    },
    /* ORDER */
    canSearchOrderSender: state => {
      return state.session.canSearchOrderSender
    },
    canSearchOrderReceiver: state => {
      return state.session.canSearchOrderReceiver
    },
    canChangeStatusOrder: state => {
      return state.session.canChangeStatusOrder
    },
    canCreateDeliveryNoteOrder: state => {
      return state.session.canCreateDeliveryNoteOrder
    },
    canCreateInvoiceOrder: state => {
      return state.session.canCreateInvoiceOrder
    },

    /* DELIVERY */
    canSearchDeliverySender: state => {
      return state.session.canSearchDeliverySender
    },
    canSearchDeliveryReceiver: state => {
      return state.session.canSearchDeliveryReceiver
    },
    canChangeStatusDeliveryNote: state => {
      return state.session.canChangeStatusDeliveryNote
    },
    canCreateInvoiceDeliveryNote: state => {
      return state.session.canCreateInvoiceDeliveryNote
    },
    /* GENRAL */
    canSearchGenralSender: state => {
      return state.session.canSearchGenralSender
    },
    canSearchGenralReceiver: state => {
      return state.session.canSearchGenralReceiver
    },
    /* CMR */
    canSearchCMR: state => {
      return state.session.canSearchCMR
    },
    canCreateCmrDraft: state => {
      return state.session.canCreateCmrDraft
    },
    canViewCmrDraftSellerCentres: state => {
      return state.session.canViewCmrDraftSellerCentres
    },
    canViewCmrDraftBuyerCentres: state => {
      return state.session.canViewCmrDraftBuyerCentres
    },
    /* SALES REPORT */
    canSearchSalesReportView: state => {
      return state.session.canSearchSalesReportView
    },
    canViewSalesReportOriginal: state => {
      return state.session.canViewSalesReportOriginal
    },
    canViewSalesReportMetadata: state => {
      return state.session.canViewSalesReportMetadata
    },
    /* INVENTORY REPORT */
    canSearchInventoryReportView: state => {
      return state.session.canSearchInventoryReportView
    },
    // COACSU / REMADV
    canCreateCoacsu: state => {
      return state.session.canCreateCoacsu
    },
    canSearchCoacsuView: state => {
      return state.session.canSearchCoacsuView
    },
    canSearchRemadvView: state => {
      return state.session.canSearchRemadvView
    },
    canViewCoacsuMetadata: state => {
      return state.session.canViewCoacsuMetadata
    },
    canViewCoacsuOriginal: state => {
      return state.session.canViewCoacsuOriginal
    },
    canViewInventoryReportOriginal: state => {
      return state.session.canViewInventoryReportOriginal
    },
    canViewInventoryReportMetadata: state => {
      return state.session.canViewInventoryReportMetadata
    },
    /* REMADV */
    canViewRemadvOriginal: state => {
      return state.session.canViewRemadvOriginal
    },
    canViewRemadvMetadata: state => {
      return state.session.canViewRemadvMetadata
    },
    /* CMR */
    canEditCarrierCMR: state => {
      return state.session.canEditCarrierCMR
    },
    canEditChargerCMR: state => {
      return state.session.canEditChargerCMR
    },

    // CONSULTA ESTADOS
    canCheckStatus: state => {
      return state.session.canCheckStatus
    },
    // UPLOAD FACTURA
    canUploadInvoice: state => {
      return state.session.canUploadInvoice
    },

    // USUARIOS
    canAdminUserAdvanced: state => {
      return state.session.canAdminUserAdvanced
    },
    canNoEditUserData: state => {
      return state.session.canNoEditUserData
    },
    canViewMetadata: state => {
      return state.session.canViewMetadata
    },
    canViewOrderMetadata: state => {
      return state.session.canViewOrderMetadata
    },
    canViewRecadvMetadata: state => {
      return state.session.canViewRecadvMetadata
    },
    canViewOrderOriginal: state => {
      return state.session.canViewOrderOriginal
    },
    canViewRecadvOriginal: state => {
      return state.session.canViewRecadvOriginal
    },
    canViewDesadvMetadata: state => {
      return state.session.canViewDesadvMetadata
    },
    canViewDesadvOriginal: state => {
      return state.session.canViewDesadvOriginal
    },

    // Adjuntos Ocultos
    canAttachmentHidden: state => {
      return state.session.canAttachmentHidden
    },

    // Canales Relaciones comerciales
    canViewRelationChannel: state => {
      return state.session.canViewRelationChannel
    },
    // ISSUES
    canSearchIssue: state => {
      return state.session.canSearchIssue
    },
    canUpdateIssue: state => {
      return state.session.canUpdateIssue
    },
    canDeleteIssue: state => {
      return state.session.canDeleteIssue
    },
    canCreateIssue: state => {
      return state.session.canCreateIssue
    },

    // - VIEJOS - //
    invoiceModal: state => {
      return state.local.invoiceModal
    },
    searchBarToggle: state => {
      return state.local.searchBarToggle
    },
    invoiceFilters: state => {
      return state.local.invoiceFilters
    },
    getSelectedFilters: state => {
      return Object.keys(state.local.invoiceFilters).map((k) => state.local.invoiceFilters[k]).filter(function (el) {
        return el.selected === true
      })
    },
    filterTable: state => {
      return state.local.tableData
    },
    totalResults: state => {
      return state.local.totalItemsTable
    },
    isShowFactura: state => {
      return state.local.isShowFactura
    },
    isShowEmision: state => {
      return state.local.isShowEmision
    },
    isShowRegistro: state => {
      return state.local.isShowRegistro
    },
    isShowVendedor: state => {
      return state.local.isShowVendedor
    },
    isShowComprador: state => {
      return state.local.isShowComprador
    },
    isShowImporte: state => {
      return state.local.isShowImporte
    },
    isShowEstado: state => {
      return state.local.isShowEstado
    },
    getDistinctColumn: state => {
      return state.local.distinctColumnData
    }
  }

})

store.subscribe((mutation, state) => {
  // Insertar en local las propiedades correspondientes a los diferentes modulos
  state.local.login = state.login.local
  state.local.usuarios = state.usuarios.local
  state.local.borradores = state.borradores.local
  state.local.servicios = state.servicios.local
  state.local.recepciones = state.recepciones.local
  state.local.pedidos = state.pedidos.local
  state.local.cierrescontables = state.cierrescontables.local
  state.local.cierrescontablesBorradores = state.cierrescontablesBorradores.local
  state.local.profile = state.profile.local
  state.local.profiles = state.profiles.local
  state.local.taxes = state.taxes.local
  state.local.articles = state.articles.local
  state.local.mailServer = state.mailServer.local
  state.local.tareaspendientes = state.tareaspendientes.local
  state.local.creacionFactura = state.creacionFactura.local
  state.local.creacionAlbaran = state.creacionAlbaran.local
  state.local.centros = state.centros.local
  state.local.facturas = state.facturas.local
  state.local.issues = state.issues.local
  state.local.filtros = state.filtros.local
  state.local.documentacion = state.documentacion.local
  state.local.auditorias = state.auditorias.local
  state.local.auditoriaAcciones = state.auditoriaAcciones.local
  state.local.plantillasdecorreo = state.plantillasdecorreo.local
  state.local.procesosPlanificados = state.procesosPlanificados.local
  state.local.estadistica = state.estadistica.local
  state.local.albaranes = state.albaranes.local
  state.local.genrals = state.genrals.local
  state.local.cmr = state.cmr.local
  state.local.ocrDocuments = state.ocrDocuments.local
  state.local.salesReport = state.salesReport.local
  state.local.inventoryReport = state.inventoryReport.local
  state.local.remadv = state.remadv.local
  state.local.coacsu = state.coacsu.local

  // Insertar en session las propiedades correspondientes a los diferentes modulos
  state.session.usuarios = state.usuarios.session
  state.session.borradores = state.borradores.session
  state.session.servicios = state.servicios.session
  state.session.cierrescontables = state.cierrescontables.session
  state.session.recepciones = state.recepciones.session
  state.session.pedidos = state.pedidos.session
  state.session.cierrescontablesBorradores = state.cierrescontablesBorradores.session
  state.session.profile = state.profile.session
  state.session.profiles = state.profiles.session
  state.session.taxes = state.taxes.session
  state.session.articles = state.articles.session
  state.session.mailServer = state.mailServer.session
  state.session.tareaspendientes = state.tareaspendientes.session
  state.session.creacionFactura = state.creacionFactura.session
  state.session.creacionAlbaran = state.creacionAlbaran.session
  state.session.centros = state.centros.session
  state.session.facturas = state.facturas.session
  state.session.issues = state.issues.session
  state.session.filtros = state.filtros.session
  state.session.documentacion = state.documentacion.session
  state.session.auditorias = state.auditorias.session
  state.session.auditoriaAcciones = state.auditoriaAcciones.session
  state.session.plantillasdecorreo = state.plantillasdecorreo.session
  state.session.procesosPlanificados = state.procesosPlanificados.session
  state.session.estadistica = state.estadistica.session
  state.session.albaranes = state.albaranes.session
  state.session.genrals = state.genrals.session
  state.session.cmr = state.cmr.session
  state.session.ocrDocuments = state.ocrDocuments.session
  state.session.salesReport = state.salesReport.session
  state.session.inventoryReport = state.inventoryReport.session

  sessionStorage.setItem('store', JSON.stringify(state.session))
})

/* Captura el evento de acceso a local o session storage. Cuando pase, que se actualice
 * el valor del state . Esto es para cuando tengamos abierto a la vez varias pestañas
 * o ventanas
 */
globalThis.addEventListener('storage', event => {
  if (event.newValue === null) return
  const local = JSON.parse(localStorage.getItem('local'))
  if (local) {
    // Aqui debemos declarar todos los modulos que insertemos en localStorage
    // con el siguiente formato:
    // state.<<modulo>>.local = session.<<modulo>>
    store.state.local = local
    store.state.usuarios.local = local.usuarios
    store.state.borradores.local = local.borradores
    store.state.servicios.local = local.servicios
    store.state.recepciones.local = local.recepciones
    store.state.pedidos.local = local.pedidos
    store.state.cierrescontables.local = local.cierrescontables
    store.state.cierrescontablesBorradores.local = local.cierrescontablesBorradores
    store.state.profile.local = local.profile
    store.state.profiles.local = local.profiles
    store.state.taxes.local = local.taxes
    store.state.articles.local = local.articles
    store.state.mailServer.local = local.mailServer
    store.state.tareaspendientes.local = local.tareaspendientes
    store.state.creacionFactura.local = local.creacionFactura
    store.state.creacionAlbaran.local = local.creacionAlbaran
    store.state.centros.local = local.centros
    store.state.facturas.local = local.facturas
    store.state.issues.local = local.issues
    store.state.filtros.local = local.filtros
    store.state.documentacion.local = local.documentacion
    store.state.auditorias.local = local.auditorias
    store.state.auditoriaAcciones.local = local.auditoriaAcciones
    store.state.plantillasdecorreo.local = local.plantillasdecorreo
    store.state.procesosPlanificados.local = local.procesosPlanificados
    store.state.estadistica.local = local.estadistica
    store.state.albaranes.local = local.albaranes
    store.state.genrals.local = local.genrals
    store.state.cmr.local = local.cmr
    store.state.ocrDocuments.local = local.ocrDocuments
    store.state.salesReport.local = local.salesReport
    store.state.inventoryReport.local = local.inventoryReport
    store.state.remadv.local = local.remadv
    store.state.coacsu.local = local.coacsu

    store.replaceState(
      Object.assign(store.state, store.state)
    )
  }
})

export default store
